import options from './list.component';

export default {
    selector: 'dtEntitiesList',
    options
};



// WEBPACK FOOTER //
// ./app/common/entities-list/index.js